import { getLocations, getProvinceById } from './getLocations'

export const Locations = {
  getLocations,
  getProvinceById,
};
